import Decimal from 'decimal.js';
const D=Decimal.clone({precision:50,rounding:Decimal.ROUND_HALF_EVEN});
export const decimal=value=>new D(String(value));
export function lineValue(line){
 try{
  const entered=line.use_unit_price?line.unit_price:line.line_value;
  if(entered===''||entered==null)return null;
  const goods=decimal(entered),share=decimal(line.adjustment||'0');
  if(!goods.isFinite()||goods.isNegative()||!share.isFinite()||share.decimalPlaces()>2||(!line.use_unit_price&&goods.decimalPlaces()>2))return null;
  const value=(line.use_unit_price?goods.times(decimal(line.quantity)).toDecimalPlaces(2):goods).plus(share);
  return value.isNegative()?null:value;
 }catch{return null;}
}
export function money(value){return decimal(value).toFixed(2);}
export function cost(value,quantity){
 try{
  if(!decimal(quantity).isPositive())return null;
  const exact=decimal(value).div(decimal(quantity)),shown=exact.toSignificantDigits(12);
  return `${shown.eq(exact)?'':'≈'}₹${shown.decimalPlaces()<2?shown.toFixed(2):shown.toString()}`;
 }catch{return null;}
}
export function allocated(lines){return lines.reduce((sum,l)=>sum.plus(lineValue(l)||decimal(0)),decimal(0));}
